import { useRouter } from 'next/router'

export interface UseGigIDs {
  channelId?: string
  webcastId?: string
  preAuthToken?: string
}

export function hasGigIDs(gigIDs: UseGigIDs): boolean {

  return typeof gigIDs.channelId === 'string' &&
    typeof gigIDs.webcastId === 'string'

}

function checkForArray(value: string | undefined | string[]): string | undefined {

  if (typeof value === 'object' && (value?.length ?? 0) > 0) return value[0]
  if (typeof value === 'string' && value !== '') return value
  return

}

export function isNumericId(value: string | undefined): string | undefined {

  try {

    if (typeof value === 'string' && (value?.trim() !== '')) {

      let finalValue = value?.trim()

      if (new RegExp(/^\d+$/).test(finalValue)) {

        return finalValue

      }

      return

    }

    return

  } catch (error) {

    return

  }

}

const useGigIDs = (): UseGigIDs => {

  const { query } = useRouter()
  const channelId = isNumericId(checkForArray(query?.channelId))
  const webcastId = isNumericId(checkForArray(query?.webcastId))
  const preAuthToken = checkForArray(query['player-preauth'])

  return {
    channelId,
    webcastId,
    preAuthToken
  }

}

export default useGigIDs
